import React from "react";
import styles from "../../../styles/home/Components/Welcome.module.css";
import apostleImage from "../../../assets/images/father.png";
import legalRepImage from "../../../assets/images/RevEspoir.png";

export default function Welcome() {
  return (
    <section className={styles.welcomeSection}>
      <div className={styles.welcomeContainer}>
        {/* Main Title */}
        <div className={styles.mainTitleContainer}>
          <h2 className={styles.mainTitle}>
            Welcome to{" "}
            <span className={styles.titleHighlight}>
              Calvary Wide Fellowship Ministries
            </span>
          </h2>
        </div>

        <div className={styles.welcomeGrid}>
          {/* Column 1 - Apostle Sebagabo Christophe */}
          <div className={styles.leaderColumn}>
            <div className={styles.apostleCard}>
              <div className={styles.leaderContent}>
                <div className={styles.leaderImageWrapper}>
                  <img
                    src={apostleImage}
                    alt="Apostle Sebagabo Christophe"
                    className={styles.leaderImage}
                  />
                  <div className={styles.imageOverlay}></div>
                </div>

                <div className={styles.leaderDetails}>
                  <h3 className={styles.leaderName}>
                    Apostle Sebagabo Christophe
                  </h3>
                  <p className={styles.leaderTitle}>
                    Senior Pastor & Founder
                  </p>

                  <div className={styles.leaderMessage}>
                    <span className={styles.quoteIcon}>"</span>
                    <p className={styles.messageText}>
                      Please allow me to personally welcome you to the Calvary
                      Wide Fellowship Ministries website. We are delighted that
                      you’re here. This platform is designed to introduce you
                      to the heart of our ministry and provide resources to
                      support your spiritual growth and wholeness in Christ.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Column 2 - Description (Middle) */}
          <div className={styles.description}>
            <p className={styles.descriptionText}>
              <strong>Calvary Wide Fellowship Ministries (CWFM)</strong> is a
              Spirit-led community committed to spreading the Gospel of Jesus
              Christ and transforming lives through the power of God’s Word.
              Built on worship, intercession, and discipleship, CWFM exists to
              create a spiritual home where believers encounter God’s presence
              and grow in their faith.
            </p>

            <p className={styles.descriptionText}>
              We believe every person is uniquely created by God with a divine
              purpose. Our mission is to raise believers who walk in the
              fullness of their faith and live out their calling boldly. Whether
              you seek spiritual growth, meaningful community, or a deeper
              relationship with God, you are welcome here.
            </p>
          </div>

          {/* Column 3 - Rev. Pr. Espoir SERUGO */}
          <div className={styles.leaderColumn}>
            <div className={styles.apostleCard}>
              <div className={styles.leaderContent}>
                <div className={styles.leaderImageWrapper}>
                  <img
                    src={legalRepImage}
                    alt="Rev. Pr. Espoir SERUGO"
                    className={styles.leaderImage}
                  />
                  <div className={styles.imageOverlay}></div>
                </div>

                <div className={styles.leaderDetails}>
                  <h3 className={styles.leaderName}>
                    Rev. Pr. Espoir SERUGO
                  </h3>
                  <p className={styles.leaderTitle}>
                    Legal Representative
                  </p>

                  <div className={styles.leaderMessage}>
                    <span className={styles.quoteIcon}>"</span>
                    <p className={styles.messageText}>
                      We invite you to explore and discover what God is doing
                      through this ministry. While this site offers a glimpse,
                      the true heart of CWFM is experienced in fellowship. We
                      look forward to welcoming you and sharing this journey of
                      faith together. Blessings.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
